import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { IS_CLIENT_USING_GUILD_AUTH } from '@src/graphql/queries/client';
import { useAuth } from '@src/hooks/useAuth';
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { useClients } from '@src/hooks/useClients';
import { Role, useSessionState } from 'pe-core-frontend';
import { createContext, useState } from 'react';
const DefaultAdminContext = {
    sidebarOpen: true,
    setSidebarOpen: () => { },
    backLink: undefined,
    setBackLink: () => { },
    currentClient: undefined,
    isUsingGuildAuth: false,
};
export const AdminContext = createContext(DefaultAdminContext);
const roles = [Role.CLAIMS_PROCESSOR, Role.MEMBER_SUPPORT];
export const AdminContextProvider = ({ children }) => {
    const { currentUser } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useSessionState('adminMenu-sidebarOpen', roles.some(i => (currentUser?.roleNames || []).includes(i))
        ? false
        : DefaultAdminContext.sidebarOpen);
    const [backLink, setBackLink] = useState(DefaultAdminContext.backLink);
    // Get current client from URL params
    const clientId = useClientIdParam();
    const { find } = useClients({ id: clientId });
    const currentClient = clientId ? find(clientId) : undefined;
    // Check if current client is using Guild Auth
    const shouldRunGuildAuthQuery = !!currentClient?.code && currentClient.code.trim() !== '';
    const { data: guildAuthData } = useQuery(IS_CLIENT_USING_GUILD_AUTH, {
        variables: { clientCode: currentClient?.code || '' },
        skip: !shouldRunGuildAuthQuery,
    });
    const isUsingGuildAuth = !!guildAuthData?.isClientUsingGuildAuth;
    const value = {
        ...DefaultAdminContext,
        sidebarOpen,
        setSidebarOpen,
        backLink,
        setBackLink,
        currentClient,
        isUsingGuildAuth,
    };
    return _jsx(AdminContext.Provider, { value: value, children: children });
};
